"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TableTitle = _styledComponents["default"].div.attrs(function () {
  return {
    className: "my-3",
    id: "table-title"
  };
}).withConfig({
  displayName: "TableTitle",
  componentId: "sc-1utdrqr-0"
})(["padding-bottom:0.25rem;font-size:16px;font-weight:300;color:#000000;width:100%;border-bottom:1px solid #d2d2d2;"]);

var _default = TableTitle;
exports["default"] = _default;